/* eslint-disable no-param-reassign */
const transition = (isOpen, setIsUiExpanded) => ({ target }) => {
    if (!isOpen()) setIsUiExpanded(false);
    target.style.maxHeight = '';
};

const openSection = (element) => {
    if (element) {
        element.style.maxHeight = `${0}px`;
        requestAnimationFrame(() => {
            element.style.maxHeight = `${element.scrollHeight}px`;
        });
    }
};

const closeSection = (element) => {
    if (element) {
        element.style.maxHeight = `${element.scrollHeight}px`;
        setTimeout(() => {
            requestAnimationFrame(() => {
                element.style.maxHeight = `${0}px`;
            });
        }, 50);
    }
};

export { openSection, closeSection, transition };
